<template>
	<div class="box-page">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0 d-flex flex-wrap">
				<div class="col-12 col-lg-8 pl-0 pr-0 pr-lg-3">
					<carousel ref="carousel" id="owl-menu" class="col-12 pl-0 pr-0" :responsive="{0:{items:1},600:{items:2},1000:{items:2}}" :margin="15" :autoplay="false" :nav="false" :loop="false" :dots="true">
						<div @click="chooseMitra(true)" class="col-12 pl-0 pr-0">
							<div :class=" mitra ? 'active' : '' " class="col-12 p-3 d-flex flex-wrap rounded-cus cus-box-shadow cursor-pointer title-transaction">
								<div class="col-8 pl-0 pr-0 mt-auto mb-auto">
									<div class="col-12 pl-1 font-size-10 ">Belanja Sebagai</div>
									<div class="col-12 pl-1 font-size-16 font-weight-bold">Mitra</div>
								</div>
								<div class="col-4 pl-0 pr-0 mt-auto mb-auto">
									<div class="col-12 pl-0 pr-0">
										<div class="col-12 pl-0 pr-0 pt-1 ml-auto round-transaction">
											<span v-if="mitra"><i class="fas fa-check"></i></span>
										</div>
									</div>
								</div>
								<div class="col-12 pt-2 pl-0 pr-0 d-flex justify-content-end">
									<div class="round-ball rounded-pill" :class="mitra && mitra ? 'bg-white color-blue' : 'color-white'">1</div>
									<div class="strip mt-auto mb-auto"></div>
									<div class="round-ball rounded-pill ml-n1" :class="step > 0 && mitra ? 'bg-white color-blue' : 'color-white'">2</div>
									<div class="strip mt-auto mb-auto"></div>
									<div class="round-ball rounded-pill ml-n1" :class="step > 1 && mitra ? 'bg-white color-blue' : 'color-white'">3</div>
									<div class="strip mt-auto mb-auto"></div>
									<div class="round-ball rounded-pill ml-n1" :class="step > 2 && mitra ? 'bg-white color-blue' : 'color-white'">4</div>
									<div class="strip mt-auto mb-auto"></div>
									<div class="round-ball rounded-pill ml-n1" :class="step > 3 && mitra ? 'bg-white color-blue' : 'color-white'">5</div>
								</div>
							</div>
						</div>
						<!-- <div @click="chooseMitra(false)" class="col-12 pl-0 pr-0" v-if="true">
							<div :class=" mitra ? '' : 'active' " class="col-12 p-3 d-flex flex-wrap rounded-cus cus-box-shadow cursor-pointer title-transaction">
								<div class="col-8 pl-0 pr-0 mt-auto mb-auto">
									<div class="col-12 pl-1 font-size-10 ">Belanja Sebagai</div>
									<div class="col-12 pl-1 pr-0 font-size-16 font-weight-bold">Mitra Baru</div>
								</div>
								<div class="col-4 pl-0 pr-0 mt-auto mb-auto">
									<div class="col-12 pl-0 pr-0">
										<div class="col-12 pl-0 pr-0 pt-1 ml-auto round-transaction">
											<span v-if="!mitra"><i class="fas fa-check"></i></span>
										</div>
									</div>
								</div>
								<div class="col-12 pt-2 pl-0 pr-0 d-flex justify-content-end">
									<div class="round-ball rounded-pill" :class="!mitra ? 'bg-white color-blue' : 'color-white'">1</div>
									<div class="strip mt-auto mb-auto"></div>
									<div class="round-ball rounded-pill ml-n1" :class="step > 0 && !mitra ? 'bg-white color-blue' : 'color-white'">2</div>
									<div class="strip mt-auto mb-auto"></div>
									<div class="round-ball rounded-pill ml-n1" :class="step > 1 && !mitra ? 'bg-white color-blue' : 'color-white'">3</div>
									<div class="strip mt-auto mb-auto"></div>
									<div class="round-ball rounded-pill ml-n1" :class="step > 2 && !mitra ? 'bg-white color-blue' : 'color-white'">4</div>
									<div class="strip mt-auto mb-auto"></div>
									<div class="round-ball rounded-pill ml-n1" :class="step > 3 && !mitra ? 'bg-white color-blue' : 'color-white'">5</div>
								</div>
							</div>
						</div> -->
					</carousel>
					<transition name="slide-fade">
						<!-- <mitra-code v-if="step == 0 && mitra"></mitra-code> -->
						<product v-if="step == 0" :key="productKey"></product>
					</transition>
					<transition name="slide-fade">
						<mitra-code v-if="step == 1 && mitra"></mitra-code>
						<!-- <product v-if="step == 1 && mitra"></product> -->
						<form-mitra v-if="step == 1 && !mitra" :registrationData="registrationData" :alert="alert"></form-mitra>
					</transition>
					<transition name="slide-fade">
						<serial ref="componentSerial" v-if="step == 2"></serial>
					</transition>
					<transition name="slide-fade">
						<payment-method ref="payment" :registrationData="registrationData" v-if="step > 2"></payment-method>
					</transition>
				</div>
				<div class="col-12 col-lg-4 pl-0 pr-0 pt-3 pt-lg-0">
					<cart ref="cart" :mitra="mitra" :registrationData="registrationData" :alert="alert"></cart>
				</div>
			</div>
		</div>

		<i-modal ref="modalAlertSerial" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal :message="alertKeranjang" type="alert" @remove="removeAlert"/>
				<!-- <div class="text-center">
					<h4>{{alertKeranjang}}</h4>
					<button @click="() => { setAlertKeranjang('') }"> OK</button>
				</div> -->
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>

		<i-modal ref="modalConfirmation" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal title="Konfirmasi" :message="confirmMessage" type="confirmation" @remove="resetConfirmMessage" @confirm="confirm"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>

		<i-modal ref="modalConfirmationpPayment" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal title="Konfirmasi Transaksi" :message="confirmPaymentMessage" type="confirmation" @remove="resetPaymentMessage" @confirm="confirmPayment"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>

		<i-modal ref="modalConfirmationPin" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<div class="modal-body pt-0 pt-md-3">
					<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center">
						<div class="col-12 pt-3 font-size-10 text-center">
                            Silahkan input PIN Anda untuk melanjutkan transaksi
                        </div>
						<div class="col-12 pt-3">
                            <input class="form-control box-blue rounded-cus font-size-10" type="text" placeholder="PIN" v-model="pin_code" :maxlength="pin_max_length">
							<div class="font-size-8 pt-1">PIN 6 digit [{{ pin_code.length}} / {{ pin_max_length }}]</div>
                            <div class="invalid-feedback d-block m-0" v-if="alertPin.pin_code">{{ alertPin.pin_code }}</div>
                        </div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div class="modal-footer justify-content-center justify-content-center">
						<button class="col-5 col-md-3 btn btn-outline-danger d-flex justify-content-center rounded-cus" @click="hideModalPin">
							<span class="font-size-11"><i class="fas fa-times"></i></span>
							<div class="font-size-11 pl-2">Batal</div>
						</button>
						<button class="col-5 col-md-3 btn btn-blue d-flex d-flex justify-content-center rounded-cus ml-3" @click="submitModalPin" :disabled="transaction_on_progress">
							<span class="font-size-11"><i class="fas fa-check"></i></span>
							<div class="font-size-11 pl-2">Ok</div>
						</button>
					</div>
				</div>
			</template>
		</i-modal>
	</div>
</template>

<script>
import carousel from 'vue-owl-carousel';
import MitraCode from '@/views/transaction/MitraCode.vue';
import Cart from '@/views/transaction/Cart.vue';
import Product from '@/views/transaction/Product.vue';
import Serial from '@/views/transaction/Serial.vue';
import PaymentMethod from '@/views/transaction/PaymentMethod.vue';
import FormMitra from '@/views/transaction/FormMitra.vue';
import IModal from '@/components/IModal.vue';
import AlertModal from '@/components/elements/alert/AlertModal.vue';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

export default {
	components: {
		carousel, Cart, Serial, PaymentMethod, FormMitra, Product, MitraCode, IModal, AlertModal
	},
	name: 'Transaction',
	data() {
		return {
			productKey: 0,
			selectedProduct: {},
			nama_produk : '',
			deskripsi_produk : '',
			product_image : '',
			confirmMessage: '',
			registrationData: {
				mitra_code: '',
				email: '',
				name: '',
				card_id: '',
				mobilephone: '',
			},
			alert: {
				mitra_code: '',
				email: '',
				name: '',
				card_id: '',
				mobilephone: '',
			},
			tempMitra: true,	
			pin_code: '',
            pin_max_length: 6,
			transaction_on_progress: false,
		}
	},
	computed: {
		...mapState('cart', ['dataProduk', 'qty_product', 'step', 'cart', 'alertKeranjang', 'confirmPaymentMessage', 'mitra', 'showModalPin', 'pinData', 'alertPin']),
		...mapState('auth', ['userData']),
		...mapGetters('auth', ['isAuth']),
	},
	methods:{
		...mapActions('registrasiList', ['registrasiStockist']),
		...mapActions('cart', ['saveCart', 'changeProductQty', 'getregisterItem', 'checkPinTransaction']),
		...mapMutations('cart', ['setMitra', 'step_up', 'step_down', 'setAlertKeranjang', 'setConfirmPaymentMessage', 'reset', 'setShowModalPin']),

		async chooseMitra(val) {
			this.tempMitra = val
			if (val !== this.mitra) {
				if ([1,2,3].includes(this.step)) {
					var tipe = ''
					if (this.tempMitra) {
						tipe = 'Mitra'
					} else {
						tipe = 'Mitra Baru'
					}
					this.confirmMessage = `Anda yakin ingin melakukan transaksi ${tipe}?`
				} else {
					// await this.reset()
					this.productKey += 1
					if (!this.tempMitra) {
						this.getregisterItem()
					}
					this.setMitra(this.tempMitra)
				}
			}
			// if (this.step == 0) {
			// 	this.reset()
			// 	this.setMitra(val)
			// 	if (!val) {
			// 		this.getregisterItem()
			// 	}
			// } else {
			// 	return false;
			// }
		},
		removeAlert() {
			this.setAlertKeranjang('')
			if (this.step > 2) {
				this.$refs.payment.setFocus()
			} else if (this.step == 2) {
				this.$refs.componentSerial.focusOnInput()
			}
		},
		resetConfirmMessage() {
			this.confirmMessage = ''
		},
		resetPaymentMessage() {
			this.setConfirmPaymentMessage('')
		},
		async confirm() {
			await this.reset()
			if (!this.tempMitra) {
				this.getregisterItem()
			}
			this.resetConfirmMessage()
			this.setMitra(this.tempMitra)
		},
		confirmPayment(){
			this.$refs.cart.bayar()
		},
		hideModalPin(){
			//this.$refs.modalConfirmationPin.modalHide()
			this.setShowModalPin(false)
			this.pin_code = ''
		},
		submitModalPin(){
			this.transaction_on_progress = true

			var params = {
				pin_code: this.pin_code
			}

			this.checkPinTransaction(params).then(() => {
				//console.log('pinData', this.pinData)

				if (this.pinData == 200) {
					//console.log('pinData 200')
					this.$refs.cart.bayar()
					this.hideModalPin()
				}

				this.transaction_on_progress = false
			})
		}
	},
	watch: {
		alertKeranjang(val){
			if (val) {
				this.$refs.modalAlertSerial.modalShow()
			} else {
				this.$refs.modalAlertSerial.modalHide()
			}
		},
		confirmMessage(val){
			if (val) {
				this.$refs.modalConfirmation.modalShow()
			} else {
				this.$refs.modalConfirmation.modalHide()
			}
		},
		confirmPaymentMessage(val){
			if (val) {
				this.$refs.modalConfirmationpPayment.modalShow()
			} else {
				this.$refs.modalConfirmationpPayment.modalHide()
			}
		},
		step(val, old){
			if (val == 0 && old != 1) {
				this.reset()
			}
		},
		showModalPin(val){
			//console.log('showModalPin', val)

			if (val == true) {
				this.$refs.modalConfirmationPin.modalShow()
			} else {
				this.$refs.modalConfirmationPin.modalHide()
			}
		}
	},
	created () {
		this.$store.dispatch('setPageTitle', 'Transaksi');
	},
	beforeDestroy(){
		this.reset()
	}
};
</script>
